package com.example.mystybag.sharedmodels.mystyBag.requestModels

import com.example.mystybag.sharedmodels.AllCommands.REQUEST_DELETE_ACCOUNT
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class DeleteAccountRequestRequestModel(
    val userId: Long = 0L,
    val message: String = ""
) : BaseRequestModel(api = REQUEST_DELETE_ACCOUNT)
